import HomePage from "../container/Homepage/index";
import PantPage from "../container/Pant/index";
import PantOrderTablePage from "../container/PantOrder/index";
import ViewPantOrderPage from "../container/PantOrder/ViewPantOrder";
import ShirtPage from "../container/Shirt/index";
import ShirtOrderTablePage from "../container/ShirtOrder/index";
import ViewShirtOrderPage from "../container/ShirtOrder/ViewShirtOrder";
import MainOrderPage from "../container/MainOrder/index";
import { MainOrder } from "../container/MainOrder/MainOrder";
import CustomerPage from "../container/Customer/index";
import { ViewMainOrder } from "../container/MainOrder/ViewMainOrder";
import { CustomerDetails } from "../container/Customer/customerDetails";
import { Example } from "../Print/Example";
import LoginPage from "../container/Auth/index";

const routes = [
  { path: "/", component: HomePage, exact: true },
  { path: "/login", component: LoginPage, exact: true },
  { path: "/customer", component: CustomerPage, exact: true },
  { path: "/customer/detail/:id", component: CustomerDetails, exact: true },
  { path: "/pant", component: PantPage, exact: true },
  { path: "/pantorder", component: PantOrderTablePage, exact: true },
  { path: "/pantorder/:id", component: ViewPantOrderPage, exact: true },
  { path: "/shirt", component: ShirtPage, exact: true },
  { path: "/shirtorder", component: ShirtOrderTablePage, exact: true },
  { path: "/shirtorder/:id", component: ViewShirtOrderPage, exact: true },
  { path: "/order/add", component: MainOrder, exact: true },
  { path: "/orders", component: MainOrderPage, exact: true },
  { path: "/order/:id", component: ViewMainOrder, exact: true },
  { path: "/print/:id", component: Example, exact: true },
];

export default routes;
